// PARA-132 (AC-12, AC-E9a, B-10) — выбор и нормализация контейнера записи.
// Конвертация/перекодирование аудио на клиенте не выполняются: на backend
// уходит ровно то, что отдал MediaRecorder.

/** Приоритетный список: audio/webm (Android/Desktop) → audio/mp4 (Safari/iOS). */
export const SUPPORTED_MIME_TYPES = ['audio/webm', 'audio/mp4'] as const;

/** Первый поддерживаемый средой контейнер либо null, если запись невозможна. */
export function pickSupportedMimeType(): string | null {
  if (typeof MediaRecorder === 'undefined') {
    return null;
  }
  return SUPPORTED_MIME_TYPES.find((type) => MediaRecorder.isTypeSupported(type)) ?? null;
}

/** MIME без параметров: 'audio/webm;codecs=opus' → 'audio/webm'. Backend строит
 * имя файла для STT-провайдера как audio.<подтип> (B-10), поэтому параметры
 * обязаны быть срезаны на фронте. */
export function normalizeAudioMime(raw: string): string {
  return raw.split(';')[0].trim();
}

/** Имя файла с корректным расширением: 'voice.webm' / 'voice.mp4'. */
export function audioFileName(mime: string): string {
  const [, subtype] = normalizeAudioMime(mime).split('/');
  return `voice.${subtype}`;
}
